import { Box, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { Text } from '../Text';

interface EmbeddedVideoProps {
  embedUrl: string;
  title: string;
  label?: string;
  size: 'small' | 'large';
}

const EmbeddedVideo: React.FC<EmbeddedVideoProps> = ({
  embedUrl,
  title,
  size,
  label,
}) => {
  const Styles = useMultiStyleConfig('EmbeddedVideo', { size });
  return (
    <Box sx={Styles.container}>
      <Box sx={Styles.frameContainer}>
        <Box
          as="iframe"
          sx={Styles.frame}
          src={embedUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={title}
        />
      </Box>
      {label && (
        <Text as="b" sx={Styles.label}>
          {label}
        </Text>
      )}
    </Box>
  );
};

export default EmbeddedVideo;
